import React, { useEffect,useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { initialFormData, initialErrors, fieldValidation  } from '../../../common/helper/form-constants.js';
import { MESSAGES } from '../../../constants/constants.js';

const EditWebhooks = (props) => {
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

  const [formData, setFormData] = useState({webhook_url:'', webhook_secret: '',webhook_alert_email:'' });
  const [errors, setErrors] = useState({ ...initialErrors });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  };

  const validateField = (fieldName, value) => {
    const errorMessage = fieldValidation(fieldName, value);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
    return errorMessage
  };
  const handleCheckboxChange = () => {
    setIsCheckboxChecked((prev) => !prev);
  }
  useEffect(() => {
    if (isCheckboxChecked) {
      setFormData((prevData) => ({
        ...prevData,
        webhook_secret: prevData.webhook_url,
        webhook_alert_email: prevData.webhook_url,
      }));
    }
  }, [isCheckboxChecked, formData.webhook_url]);
  const onSave = (e) => {
    e.preventDefault();
    let hasErrors;
    Object.keys(formData).forEach(fieldName => {
      const error = validateField(fieldName, formData[fieldName]);
      if (error) {
          hasErrors = true;
      }
  });
  if(!hasErrors) {
    props.onSubmit(formData);
  }
    
  }
  useEffect(() => {
    console.log(props) // coming
    if(props && props.data) {
      setFormData({
        webhook_url:props.data.webhook_url_success, webhook_secret: props.data.webhook_url_pending,webhook_alert_email:props.data.webhook_url_fail
      })
    }
    console.log(formData)

  }, []);

    return (
      <>
       <Modal  {...props}>
        <Modal.Header closeButton>
          <Modal.Title> Edit Webhooks</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form action="#" method="post">
            <div className="form-group" style={{ textAlign: 'left', marginBottom: '5px' }}>
              <label htmlFor="keyid">Success URL</label>
              <input
                type="checkbox"
                style={{ float: 'right' }}
                checked={isCheckboxChecked}
                onChange={handleCheckboxChange}
              /> 
               <label htmlFor="keyid"   style={{ float: 'right', margin:'3px' }}>Same as success url</label>
              
              <input
                type="text"
                className={`form-control ${errors.webhook_url ? 'is-invalid' : ''}`}
                id="email"
                placeholder="Enter Success URL"
                value={formData.webhook_url}
                name="webhook_url"
                onChange={handleChange}
              />
              {errors.webhook_url && <div className="invalid-feedback">{errors.webhook_url}</div>}
            </div>
            <div className="form-group" style={{ textAlign: 'left', marginBottom: '5px' }}>
              <label htmlFor="keysecret">Failure URL</label>
              <input
                type="text"
                className={`form-control ${errors.webhook_secret ? 'is-invalid' : ''}`}
                id="secret"
                placeholder="Failure URL"
                name="webhook_secret"
                value={formData.webhook_secret}
                onChange={handleChange}
                disabled={isCheckboxChecked}
              />
              {errors.webhook_secret && <div className="invalid-feedback">{errors.webhook_secret}</div>}
            </div>
            <div className="form-group" style={{ textAlign: 'left', marginBottom: '5px' }}>
              <label htmlFor="keysecret">Pending URL</label>
              <input
                type="email"
                className={`form-control ${errors.webhook_alert_email ? 'is-invalid' : ''}`}
                id="email"
                placeholder="Enter Pending URL"
                value={formData.webhook_alert_email}
                name="webhook_alert_email"
                onChange={handleChange}
                disabled={isCheckboxChecked}
              />
              {errors.webhook_alert_email && <div className="invalid-feedback">{errors.webhook_alert_email}</div>}
            </div>
          </form>

        {/* <form action="#" method="post">
        <div className="form-group" style={{textAlign: 'left', marginBottom: '5px'}}>
          <label htmlFor="keyid">Webhook URL</label>
          <input type="text" className={`form-control ${errors.webhook_url ? 'is-invalid' : ''}`}   id="email" placeholder="Enter Webhook URL" value ={formData.webhook_url} name="webhook_url"  onChange={handleChange} />
          {errors.webhook_url && <div className="invalid-feedback">{errors.webhook_url}</div>}
        </div>
        <div className="form-group" style={{textAlign: 'left', marginBottom: '5px'}}>
          <label htmlFor="keysecret">Secret</label>
          <input type="text" className={`form-control ${errors.webhook_secret ? 'is-invalid' : ''}`}   id="secret" placeholder="Enter Secret" name="webhook_secret" value ={formData.webhook_secret} onChange={handleChange} />
          {errors.webhook_secret && <div className="invalid-feedback">{errors.webhook_secret}</div>}
        </div>
        <div className="form-group" style={{textAlign: 'left', marginBottom: '5px'}}>
          <label htmlFor="keysecret">Alert Email</label>
          <input type="email" className={`form-control ${errors.webhook_alert_email ? 'is-invalid' : ''}`}   id="email" placeholder="Enter Alert Email"   value ={formData.webhook_alert_email} name="webhook_alert_email"  onChange={handleChange} />
          {errors.webhook_alert_email && <div className="invalid-feedback">{errors.webhook_alert_email}</div>}
        </div>
      </form> */}
            
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onHide}>
            Close
          </Button>
          <Button variant="primary" onClick={onSave}>
            sumbit
          </Button>
        </Modal.Footer>
      </Modal>
      </>
    );
  }
  


  export default EditWebhooks;



